import {
  provideAiAgentClientTools,
  provideAiAgentContextSource,
} from '@softapps/ai-agent';
import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { salesStatisticsContextSource } from './agent/sales-statistics-agent.context';
import {
  openSalesStatisticsTool,
  setStatisticsFilterTool,
} from './agent/sales-statistics-agent.tools';
import { salesStatisticsRoutes } from './sales-statistics.routes';
import { SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK } from '@softapps/wws/core';

export interface SalesStatisticsModuleConfig {
  /** Registers the ai-agent tools and context source; pair with `provideAiAgentModule()`. */
  aiAgent?: boolean;
}

export const provideSalesStatisticsModule = (config?: SalesStatisticsModuleConfig) => {
  return [
    // The dependency runs this way only: ai-agent must not import a remote.
    ...(config?.aiAgent === true
      ? [
          provideAiAgentClientTools(openSalesStatisticsTool, setStatisticsFilterTool),
          provideAiAgentContextSource(salesStatisticsContextSource),
        ]
      : []),
    provideSoftAppsModule(
      {
        name: 'SalesStatistics',
        title: '#SALES_STATISTICS.MODULE_TITLE',
        icon: 'fa-regular fa-chart-mixed-up-circle-dollar',
        route: '/sales-statistics/dashboard',
        permission: SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK,
        group: getModuleGroupByName('Statistik'),
      },
      withSoftAppsModuleRoutes({ app: salesStatisticsRoutes }),
      withSoftAppsModuleTranslation({ de, en }),
      withSoftAppsModuleInfo({
        library: '@softapps/wws/sales-statistics',
        description: 'Verkaufsstatistik mit Tabelle und Charts.',
      })
    ),
  ];
};
